import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { s as styles } from './bottom-sheet-1YgEly-x.js';

const BottomSheetIFrameAdapter = ({ children }) => {
    const touchEventsInterceptorRef = useRef(null);
    useEffect(() => {
        const touchEventsInterceptor = touchEventsInterceptorRef.current;
        const handleTouchStart = (event) => {
            const target = event.target;
            target.style.pointerEvents = 'none';
            setTimeout(() => {
                target.style.pointerEvents = 'auto';
            }, 300);
        };
        touchEventsInterceptor?.addEventListener('touchstart', handleTouchStart);
        return () => touchEventsInterceptor?.removeEventListener('touchstart', handleTouchStart);
    }, []);
    return (jsxs("div", { className: styles.iframeWrapper, children: [children, jsx("div", { className: styles.iframeEventsInterceptor, ref: touchEventsInterceptorRef })] }));
};

export { BottomSheetIFrameAdapter };
//# sourceMappingURL=BottomSheetIFrameAdapter.js.map
